import { Component } from 'react';
import { Button } from 'react-bootstrap';

// A widget that throws while rendering inside the pop-out window must never
// unmount the dashboard tree; contain the failure to the window and offer
// the way back to the normal widget view.
class PopoutErrorBoundary extends Component {
  state = { hasRenderError: false };

  static getDerivedStateFromError() {
    return { hasRenderError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error(
      this.props.isPoppedOut
        ? 'Widget failed to render in its pop-out window:'
        : 'Widget failed to render:',
      error,
      errorInfo,
    );
  }

  componentDidUpdate(previousProps) {
    if (this.state.hasRenderError && previousProps.isPoppedOut && !this.props.isPoppedOut) {
      this.setState({ hasRenderError: false });
    }
  }

  render() {
    if (this.state.hasRenderError) {
      return (
        <div className="d-flex flex-column h-100 w-100 align-items-center justify-content-center gap-3 p-4 text-center">
          <p className="m-0">
            {this.props.isPoppedOut
              ? 'This widget could not be shown in a separate window.'
              : 'This widget could not be displayed.'}
          </p>
          {typeof this.props.onReturn === 'function' && (
            <Button variant="primary" size="sm" onClick={this.props.onReturn}>
              Return to dashboard
            </Button>
          )}
        </div>
      );
    }

    return this.props.children;
  }
}

export default PopoutErrorBoundary;
